
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    sm: Boolean,
  },
});
